<template>
  <v-container>
    <v-layout>
      <v-flex lg6 md8 sm10 xs12 offset-lg3 offset-md2 offset-sm1>
        <v-card>
          <v-card-title>
            {{ title }}
          </v-card-title>
          <v-card-text>
            <div v-if="spacer">
              <v-select
                label="Özel Boşluk"
                :items="specialSpacerList"
                v-model="specialSpacer"
                :disabled="!!spacerAlignment || !!spacerText"
              >
                <template #item="{ item }">
                  <spacer-special :characterBlock="item"></spacer-special>
                </template>
              </v-select>

              <v-row>
                <v-col>
                  <v-select
                    label="Hizalama"
                    :items="spacerAlignmentList"
                    v-model="spacerAlignment"
                    :disabled="!!specialSpacer"
                  >
                  </v-select>
                </v-col>
                <v-col>
                  <v-text-field
                    label="Metin"
                    v-model="spacerText"
                    :disabled="!!specialSpacer"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
            </div>

            <v-text-field
              v-else
              label="Ad"
              v-model="channelName"
              :disabled="$store.state.query.loading"
            >
            </v-text-field>

            <v-text-field
              type="password"
              label="Şifre"
              v-model="channelPassword"
              :disabled="$store.state.query.loading"
            ></v-text-field>
            <v-text-field
              label="Konu"
              v-model="channelTopic"
              :disabled="$store.state.query.loading"
            ></v-text-field>
            <v-textarea
              label="Açıklama"
              v-model="channelDescription"
              :disabled="$store.state.query.loading"
            ></v-textarea>
            <v-expansion-panels accordion flat>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  Daha Fazla Seçenek
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card outlined>
                    <v-card-text>
                      <v-layout wrap>
                        <v-flex xs12>
                          <v-autocomplete
                            :items="channelOrderSelection"
                            label="Bu Kanalı Şundan Sonra Sırala"
                            v-model="selectedChannelOrder"
                            :disabled="$store.state.query.loading"
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex md4>
                          <v-radio-group
                            label="Maks. Kullanıcı"
                            v-model="channelUnlimitedClients"
                          >
                            <v-radio label="Sınırsız" :value="1"></v-radio>
                            <v-radio label="Sınırlı" :value="0"></v-radio>
                          </v-radio-group>
                          <v-text-field
                            label="Kullanıcı Sayısı"
                            v-model="channelMaxClients"
                            :disabled="!!channelUnlimitedClients"
                          ></v-text-field>
                        </v-flex>
                        <v-flex md4>
                          <v-radio-group
                            label="Kanal Türü"
                            v-model="channelType"
                          >
                            <v-radio label="Geçici" value="temporary"></v-radio>
                            <v-radio label="Kalıcı" value="permanent"></v-radio>
                            <v-radio
                              label="Yarı Kalıcı"
                              value="semi-permanent"
                            ></v-radio>
                          </v-radio-group>
                        </v-flex>
                        <v-flex md4>
                          <v-checkbox
                            label="Varsayılan Kanal"
                            v-model="channelIsDefault"
                            :disabled="!!initChannelData.channelFlagDefault"
                          ></v-checkbox>
                        </v-flex>
                        <v-flex md4>
                          <v-checkbox
                            label="Ses Verisi Şifreli"
                            v-model="channelIsUnencrypted"
                          ></v-checkbox>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              text
              @click="save"
              :disabled="this.$store.state.query.loading"
              color="primary"
              >OK</v-btn
            >
            <v-btn text @click="$router.go(-1)" color="primary">Cancel</v-btn>
            <v-btn
              text
              @click="save"
              :disabled="this.$store.state.query.loading"
              color="primary"
              :class="{ 'd-none': !applyButton }"
              >Apply</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// Dynamic importing the component will throw an error when used in the v-select component
import SpacerSpecial from "@/components/SpacerSpecial";

export default {
  components: {
    SpacerSpecial,
  },
  props: {
    title: String,
    applyButton: {
      type: Boolean,
      default: false,
    },
    channel: {
      type: Object,
      // Object or array defaults must be returned from a factory function
      // See: https://vuejs.org/v2/guide/components-props.html
      default() {
        return {};
      },
    },
    spacer: Boolean,
  },
  data() {
    return {
      initChannelData: {},
      channels: [],
      parentChannelId: this.$route.query.pid ? this.$route.query.pid : "0",
      serverInfo: {},
      specialSpacerList: ["", "---", "...", "-.-", "___", "-.."],
      specialSpacer: "",
      spacerAlignmentList: [
        { text: "", value: "" },
        { text: "sol", value: "l" },
        { text: "orta", value: "c" },
        { text: "sağ", value: "r" },
      ],
      spacerAlignment: "",
      spacerText: "",
    };
  },
  computed: {
    channelOrderSelection() {
      let rootChannelName = {};
      let siblingChannels = this.channels
        .filter((channel) => {
          return (
            channel.pid === this.parentChannelId &&
            channel.cid !== this.$route.params.cid
          );
        })
        .map((channel) => ({ text: channel.channelName, value: channel.cid }));

      if (this.parentChannelId !== "0") {
        let rootChannel = this.channels.find(
          (channel) => channel.cid === this.parentChannelId
        );

        rootChannelName = rootChannel && rootChannel.channelName;
      } else {
        rootChannelName = this.serverInfo.virtualserverName;
      }

      siblingChannels.unshift({ text: rootChannelName, value: 0 });

      return siblingChannels;
    },
    selectedChannelOrder: {
      get() {
        console.log(this.channel.channelOrder);

        return this.channel.channelOrder && this.channel.channelOrder;
      },
      set(cid) {
        this.channel.channelOrder = cid;
      },
    },
    channelName: {
      get() {
        return this.channel.channelName && this.channel.channelName;
      },
      set(name) {
        this.channel.channelName = name;
      },
    },
    channelPassword: {
      get() {
        return this.channel.channelPassword && this.channel.channelPassword;
      },
      set(password) {
        this.channel.channelPassword = password;
      },
    },
    channelTopic: {
      get() {
        return this.channel.channelTopic && this.channel.channelTopic;
      },
      set(topic) {
        this.channel.channelTopic = topic;
      },
    },
    channelDescription: {
      get() {
        return (
          this.channel.channelDescription && this.channel.channelDescription
        );
      },
      set(description) {
        this.channel.channelDescription = description;
      },
    },
    channelUnlimitedClients: {
      get() {
        return (
          this.channel.channelFlagMaxclientsUnlimited &&
          this.channel.channelFlagMaxclientsUnlimited
        );
      },
      set(limited) {
        this.channel.channelFlagMaxclientsUnlimited = +limited;
      },
    },
    channelType: {
      get() {
        if (this.channel.channelFlagPermanent) {
          return "permanent";
        } else if (this.channel.channelFlagSemiPermanent) {
          return "semi-permanent";
        } else {
          return "temporary";
        }
      },
      set(type) {
        if (type === "permanent") {
          this.channel.channelFlagSemiPermanent = 0;
          this.channel.channelFlagPermanent = 1;
        } else if (type === "semi-permanent") {
          this.channel.channelFlagSemiPermanent = 1;
          this.channel.channelFlagPermanent = 0;
        } else {
          this.channel.channelFlagSemiPermanent = 0;
          this.channel.channelFlagPermanent = 0;
        }
      },
    },
    channelMaxClients: {
      get() {
        return this.channel.channelMaxclients && this.channel.channelMaxclients;
      },
      set(number) {
        this.channel.channelMaxclients = number;
      },
    },
    channelIsUnencrypted: {
      get() {
        return typeof this.channel.channelCodecIsUnencrypted !== "undefined"
          ? !!!this.channel.channelCodecIsUnencrypted
          : false;
      },
      set(encrypted) {
        this.channel.channelCodecIsUnencrypted = +!encrypted;
      },
    },
    channelIsDefault: {
      get() {
        return (
          this.channel.channelFlagDefault && this.channel.channelFlagDefault
        );
      },
      set(flag) {
        this.channel.channelFlagDefault = +flag;
      },
    },
  },
  methods: {
    setSpacer() {
      let randomId = Math.floor(Math.random() * 100);

      this.channel.channelName = `[${this.spacerAlignment}spacer${randomId}]${
        this.specialSpacer || this.spacerText
      }`;
    },
    getServerInfo() {
      return this.$TeamSpeak.execute("serverinfo").then((arr) => arr.pop());
    },
    getChannelList() {
      return this.$TeamSpeak.execute("channellist");
    },
    getChanges() {
      let changes = {};

      for (let prop in this.channel) {
        if (this.channel[prop] !== this.initChannelData[prop]) {
          changes[prop] = this.channel[prop];
        }
      }

      return changes;
    },
    save(e) {
      if (this.spacer) this.setSpacer();

      this.$emit("save", this.getChanges(), e);

      if (e.target.textContent.toLowerCase() === "apply") {
        let unwatch = this.$watch("channel", (channel) => {
          this.initChannelData = { ...channel };

          unwatch();
        });
      }
    },
  },
  async created() {
    let unwatch = this.$watch(
      "channel",
      (channel) => {
        if (channel) {
          this.initChannelData = { ...this.channel };

          if (unwatch) unwatch();
        }
      },
      { immediate: true }
    );

    try {
      this.channels = await this.getChannelList();
      this.serverInfo = await this.getServerInfo();
    } catch (err) {
      this.$toast.error(err.message);
    }
  },
};
</script>
